import React, {PropsWithChildren} from 'react'

import HighlightOffSharpIcon from '@mui/icons-material/HighlightOffSharp'
import {
  Box,
  BoxProps,
  Button,
  ButtonProps,
  IconButton,
  InputProps,
} from '@mui/material'
import {makeStyles} from 'tss-react/mui'

type BaseFileInputProps = Pick<InputProps, 'onChange' | 'disabled'> &
  Pick<BoxProps, 'minWidth' | 'maxWidth'> &
  Pick<ButtonProps, 'startIcon' | 'endIcon' | 'size' | 'color'> & {
    accept: string
    id: string
    clearable?: boolean
    onClear?: React.Dispatch<string>
    fileInputRef?: React.RefObject<HTMLInputElement> | null
  }

type FileInputProps = PropsWithChildren<BaseFileInputProps>

const useStyles = makeStyles()(() => ({
  input: {
    display: 'none',
  },
}))

export const FileInput = (props: FileInputProps) => {
  const {
    accept,
    id,
    startIcon,
    endIcon,
    size = 'medium',
    color = 'primary',
    children,
    disabled,
    onChange,
    clearable = false,
    onClear,
    fileInputRef,
    ...boxProps
  } = props
  const {classes} = useStyles()

  const handleClear = () => {
    const fileInput = document.getElementById(id) as HTMLInputElement
    if (fileInput) {
      fileInput.value = ''
      if (onClear) {
        onClear(id)
      }
    }
  }

  const hasFile = () => {
    const fileInput = document.getElementById(id) as HTMLInputElement
    if (fileInput) {
      return fileInput.files ? fileInput.files.length > 0 : false
    }
  }
  return (
    <Box {...boxProps}>
      <input
        className={classes.input}
        onChange={onChange}
        accept={accept}
        id={id}
        data-testid={id}
        ref={fileInputRef}
        type={'file'}
        disabled={disabled}
      />
      <label htmlFor={id}>
        <Button
          size={size}
          variant={'contained'}
          component={'span'}
          startIcon={startIcon}
          endIcon={endIcon}
          color={color}
          disabled={disabled}
        >
          {children}
        </Button>
      </label>
      {clearable && hasFile() && (
        <IconButton
          color={'primary'}
          edge={'end'}
          onClick={handleClear}
          type={'button'}
          size='large'
        >
          <HighlightOffSharpIcon />
        </IconButton>
      )}
    </Box>
  )
}
